export default function Touch(el, binding) {
  const _self = this;
  let longTapFlag = false;
  _self.obj = el;
  _self.binding = binding;
  _self.timeOutEvent = null;
  _self.callBack =
    typeof binding.value == "object" ? binding.value.fn : binding.value;
  _self.cancel = binding.value && binding.value.cancel;
  _self.obj.addEventListener("contextmenu", function(e) {});
  _self.obj.addEventListener(
    "touchstart",
    function(e) {
      // clearTimeout(_self.timeOutEvent);
      _self.timeOutEvent = setTimeout(function() {
        // e.preventDefault();
        longTapFlag = true;
        _self.callBack(el, binding.value);
      }, 500);
      // return false;
    },
    false
  );

  _self.obj.addEventListener(
    "touchmove",
    function(e) {
      longTapFlag && _self.cancel && _self.cancel();
      longTapFlag = false;
      clearTimeout(_self.timeOutEvent);
    },
    false
  );

  _self.obj.addEventListener(
    "touchend",
    function(e) {
      longTapFlag && _self.cancel && _self.cancel();
      longTapFlag = false;
      clearTimeout(_self.timeOutEvent);
      return false;
    },
    false
  );
}
